const React = require('react');
const {
  UserContextProvider,
} = require('./src/utils/hooks/useUserContext/context');

import { QueryClientProvider } from 'react-query';

import { queryClient } from './src/utils/api/instances';
require('./src/fonts/ew-font.css');

const wrapRootElement = ({ element }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <UserContextProvider>{element}</UserContextProvider>
    </QueryClientProvider>
  );
};

const onClientEntry = () => {
  // IntersectionObserver polyfill
  if (typeof window.IntersectionObserver === `undefined`) {
    import(`intersection-observer`);
  }
};

// Temporary code for the FS - FSC combined pdp a/b test
export const onRouteUpdate = () => {
  window.locations = window.locations || [document.referrer];
  locations.push(window.location.href);
  // Save the previous location in this variable
  window.previousLocation = locations[locations.length - 2];
};

export { wrapRootElement, onClientEntry };
